export default {"src":"/_next/static/media/closed_eye.49c8abcf.svg","height":25,"width":25};